// ─────────────────────────────────────────────────────────────────
// Glass-i — Voucher frontend constants (Stage 6B.4 + 6B.9C).
// Lockstep with backend accounts.constants.js VOUCHER_TYPES + STATUSES.
// ─────────────────────────────────────────────────────────────────

export const VOUCHER_STATUSES = ['draft', 'posted', 'cancelled'];
export const VOUCHER_TYPES = [
  'journal', 'payment', 'receipt', 'sales',
  'purchase', 'credit_note', 'debit_note', 'adjustment',
  // Stage 6B.9C — Contra Voucher (cash/bank transfers).
  'contra'
];

export const STATUS_COLOR = {
  draft:     'default',
  posted:    'green',
  cancelled: 'red'
};

export const STATUS_LABEL = {
  draft:     'Draft',
  posted:    'Posted',
  cancelled: 'Cancelled'
};

export const VOUCHER_TYPE_LABEL = {
  journal:     'Journal',
  payment:     'Payment',
  receipt:     'Receipt',
  sales:       'Sales',
  purchase:    'Purchase',
  credit_note: 'Credit Note',
  debit_note:  'Debit Note',
  adjustment:  'Adjustment',
  contra:      'Contra'
};
